import React from 'react'
import { injectIntl } from 'sb-react-intl'

import Box from 'components/_new/layout/Box/Box'

import EditableAddressField from '../EditableAddressField/EditableAddressField'
import ReadableAddressField from '../ReadableAddressField/ReadableAddressField'

import s from './Address.scss'
import messages from './messages'


const Address = ({ valueLink, name, editableFields, intl }) => (
  <Box className={s.address} mt="4" pl="24">
    {
      Object.keys(valueLink).map((linkName) => (
        name === 'recommend' && editableFields.includes(linkName)
          ? <EditableAddressField key={linkName} valueLink={valueLink[linkName]} ariaLabel={intl.formatMessage(messages.ariaLabels[linkName])} />
          : <ReadableAddressField key={linkName} valueLink={valueLink[linkName]} />
      ))
    }
  </Box>
)


export default injectIntl(Address)
